import { checkoutUserErrorFragment } from './fragmentGeneral.gql';
import checkoutFragment from './fragmentCheckout.gql';

/*
	checkoutId ( ID! ) required
	The checkout on which to update line items.

	lineItems ( [CheckoutLineItemUpdateInput!]! ) required
	Line items to update.

		customAttributes ([AttributeInput!])
		Extra information in the form of an array of Key-Value pairs about the line item.

		id (ID)
		The identifier of the line item.

		quantity (Int)
		The quantity of the line item.

		variantId (ID)
		The variant identifier of the line item.
*/

const checkoutLineItemsUpdate = (
	`mutation ($checkoutId: ID!, $lineItems: [CheckoutLineItemUpdateInput!]!) {
		checkoutLineItemsUpdate(checkoutId: $checkoutId, lineItems: $lineItems) {
			checkoutUserErrors ${checkoutUserErrorFragment}
			checkout ${checkoutFragment}
		}
	}`
);

export default checkoutLineItemsUpdate;
